import React from "react";
import Layout from "components/Layout";
import { get_tdk } from "api/server/tdk";
import { Util } from "@xt/xtbase";
import useIsDesktop from "@/hooks/useIsDesktop";
import HomeAssetOverview from "components/Pages/Home/HomeAssetOverview";
import HomePcView from "components/Pages/Home/HomePc";
import AppAd from "components/Pages/Home/AppAd";
import FloatingAdvert from "components/Pages/Home/FloatingAdvert";
import HomeNewUserOverlay from "components/Pages/Home/HomeNewUserOverlay";
import HomeRegisterCouponModal from "components/Pages/Home/HomeRegisterCouponModal";

const { getOrigin } = Util;

/** 与公告区背景一致；与 Layout `paddingBottom` 表达式完全一致（不改 padding 数值） */
const HOME_PAGE_BG_BOTTOM_FILL = "#282a30";
const HOME_PAGE_BG_MAIN = "#181a20";
/** 与 Layout `paddingBottom` 同源，用于渐变里「从底部往上」的着色高度 */
const PAD_BOTTOM_EXPR = "80px + env(safe-area-inset-bottom, 0px)";
/**
 * 从底部向上铺色：色标用与 padding 相同的 calc(px)，避免 to bottom + 100% 与真实留白累计误差产生细缝。
 * 仍须覆盖 `.page` 的 background-size:cover。
 */
const HOME_PAGE_EDGE_GRADIENT = `linear-gradient(to top,
  ${HOME_PAGE_BG_BOTTOM_FILL} 0px,
  ${HOME_PAGE_BG_BOTTOM_FILL} calc(${PAD_BOTTOM_EXPR}),
  ${HOME_PAGE_BG_MAIN} calc(${PAD_BOTTOM_EXPR}),
  ${HOME_PAGE_BG_MAIN} 100%)`;

export default function HomePage(props) {
  const { isDesktop, isReady } = useIsDesktop();
  const isSpikexPc = isReady && isDesktop;

  return (
    <Layout
      isShowFoot={!!isSpikexPc}
      useSiteFooter={!!isSpikexPc}
      style={
        isSpikexPc
          ? { backgroundColor: HOME_PAGE_BG_MAIN }
          : {
              backgroundColor: HOME_PAGE_BG_MAIN,
              backgroundImage: HOME_PAGE_EDGE_GRADIENT,
              backgroundSize: "100% 100%",
              backgroundPosition: "left bottom",
              backgroundRepeat: "no-repeat",
            }
      }
    >
      {/* isReady 后再切换，避免 PC 首屏闪一下 H5 钱包首页 */}
      {!isReady ? null : isSpikexPc ? (
        <>
          <HomePcView />
          <AppAd />
          <FloatingAdvert />
        </>
      ) : (
        <>
          <div className="home-page">
            <HomeAssetOverview />
            <AppAd />
            <FloatingAdvert />
          </div>
          <HomeNewUserOverlay />
          <HomeRegisterCouponModal />
        </>
      )}
    </Layout>
  );
}

export async function getStaticProps(context) {
  const resolvedUrl = "";
  const props = { resolvedUrl: "/" };
  try {
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  } catch (error) {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  return {
    props,
    revalidate: 60
  };
}
